module.exports = __webpack_public_path__ + "static/images/stay-contactable.2hper_2.svg";